<script setup lang="ts">
import type { BlogStoryblok } from "~/types/storyblok";
import { formatDateDistance } from "~/helpers/formatters";

const props = defineProps<{ blok: BlogStoryblok }>();
useStoryblokSeo(props.blok);
</script>

<template>
	<div v-editable="blok" class="bg-sand pt-6">
		<div class="space-y-10">
			<div class="container max-w-[726px] flex flex-col gap-y-4">
				<h1 class="text-xl md:text-[2.1875rem] font-bold">
					{{ blok.title }}
				</h1>
				<p class="text-base leading-7">
					{{ blok.description }}
				</p>
				<div class="grid sm:grid-cols-2 grid-cols-1 justify-between w-full">
					<span class="text-[0.8125rem] font-medium">Leestijd: {{ blok.readingTime }} min </span>
					<span class="text-[0.8125rem] font-medium sm:text-right">
						Gepubliceerd: {{ formatDateDistance(blok.published_at) }}
					</span>
				</div>
			</div>
			<div class="md:container">
				<NuxtImg
					:src="blok.image.filename"
					:alt="blok.image.alt"
					class="object-cover aspect-[49/33] md:aspect-[35/18] md:rounded-2xl"
					provider="storyblok"
					:modifiers="{ filters: { focal: blok.image.focus } }"
					sizes="xl:95vw lg:95vw md:95vw sm:100vw xs:100vw"
					:quality="90"
				/>
			</div>
			<div v-html="renderRichText(blok.richtext)" class="container max-w-[726px] richtext" />
		</div>
		<StoryblokComponent v-for="body in blok.body" :key="body._uid" :blok="body" />
	</div>
</template>

<style>
.richtext > p {
	@apply text-base leading-7;
}
</style>
